'use strict';

import http from '@/utils/http';

export default {
  getList(code, params) {
    return http.get('/authority/dataObject/list', { params, code });
  },
  getListByRoleId(code, roleId) {
    return http.get(`/authority/dataScope/authority/${roleId}`, { code });
  },
  add(code, data) {
    return http.post('/authority/dataObject', data, { code });
  },
  update(code, data) {
    return http.put('/authority/dataObject', data, { code });
  },
  delete(code, params) {
    return http.delete('/authority/dataObject', { params, code });
  },
  saveListToRole(code, data) {
    return http.post('/authority/dataScope/authority', data, { code });
  },
};
